module.exports = __webpack_public_path__ + "img/pay-layout-2.b06c0909.svg";